/* sz-htc-v4.js — HTC accordion + 2D/3D toggle
 * Loaded via {{ 'sz-htc-v4.js' | asset_url | script_tag: defer: true }}
 *
 * Wires:
 *  - Accordion: click .oB-step-head → toggle .active on parent .oB-step (single-open)
 *  - 2D/3D tabs: click .oB-vid-tab → swap visible .oB-vid + swap step description text
 *  - Play overlay: click .oB-vid-play → play video at 2x speed, hide overlay
 */
(function () {
  'use strict';

  function initAccordion(container) {
    var steps = container.querySelectorAll('.oB-step');
    steps.forEach(function (step) {
      var head = step.querySelector('.oB-step-head');
      if (!head) return;
      head.addEventListener('click', function () {
        var isActive = step.classList.contains('active');
        steps.forEach(function (s) { s.classList.remove('active'); });
        if (!isActive) step.classList.add('active');
      });
    });
  }

  function initVidTabs(wrap) {
    var tabs = wrap.querySelectorAll('.oB-vid-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-target');
        if (!targetId) return;
        switchTab(tab, targetId);
      });
    });
  }

  function switchTab(btn, vidId) {
    var wrap = btn.closest('.oB-vid-wrap');
    if (!wrap) return;
    wrap.querySelectorAll('.oB-vid-tab').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
    wrap.querySelectorAll('.oB-vid').forEach(function (v) {
      v.style.display = 'none';
      var vid = v.querySelector('video');
      if (vid) { try { vid.pause(); vid.currentTime = 0; } catch (e) {} }
    });
    var target = document.getElementById(vidId);
    if (target) {
      target.style.display = '';
      var playBtn = target.querySelector('.oB-vid-play');
      if (playBtn) playBtn.style.display = '';
    }
    // Swap step descriptions to match 2D/3D mode
    var mode = vidId.indexOf('-2d-') !== -1 ? '2d' : '3d';
    var tut = btn.closest('.oB-tut');
    if (tut) {
      tut.querySelectorAll('.oB-step-desc[data-desc-2d]').forEach(function (desc) {
        var text = desc.getAttribute('data-desc-' + mode);
        if (text) desc.textContent = text;
      });
    }
  }

  function initPlayOverlay(wrap) {
    wrap.querySelectorAll('.oB-vid-play').forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        var v = overlay.parentElement.querySelector('video');
        if (!v) return;
        try { v.playbackRate = 2; v.play(); } catch (e) {}
        overlay.style.display = 'none';
      });
    });
  }

  function init() {
    document.querySelectorAll('.oB-tut').forEach(function (tut) {
      var stepsContainer = tut.querySelector('.oB-steps');
      if (stepsContainer) initAccordion(stepsContainer);
      var vidWrap = tut.querySelector('.oB-vid-wrap');
      if (vidWrap) {
        initVidTabs(vidWrap);
        initPlayOverlay(vidWrap);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for debugging / potential external triggers
  window.szHtcV4 = { init: init, switchTab: switchTab };
})();
